import React, {useState,useEffect,useContext} from "react";

import { Link,useNavigate } from 'react-router-dom';
import Context from '../context/context';
import ReactGA from 'react-ga4';

import Coppie from '../recensioni/coppie';

import * as config from "../_helpers/configServizi";
import Lang from "../lang/translations";

export default function Homepage(props) {

   

    const domain = window.location.hostname;

    const url_logo = config.servizi[domain].logo_su_chiaro;
    const  context = useContext(Context)
    let navigate = useNavigate();

    useEffect(() => { 
        // Rendiamo la chiusura del modal condizionale
        if (context.popupHook?.provenienza !== "impostaRegione"){
            context.setModalShowHook(false);
        }

        if(window.location.hostname=="dating.yooppe.com"){
            window.location.replace("https://www.yooppe.com");
        }
        //ReactGA.pageview('/homepage', "Homepage")
	},[]);
    
   

    return (<div className="homepage_style">
                <nav>
                    <div className="navbar navbar-default navbar-fixed-top" role="navigation">
                        <div className="container">
                                <div className="navbar-header">
                                    <Link className="navbar-brand" to="/"><img src={config.servizi[domain].logo_navbar_desktop} className="img-fluid" /></Link>
                                </div>
                               

                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            </div>
                        </div>
                    </div>
                </nav>

                <nav className="navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-block">
                    <div className="container navbar-desktop">
                        <Link className="navbar-brand" to="/"><img src={config.servizi[domain].logo_navbar_desktop} className="img-fluid" /></Link>
                        <div className="navbar-collapse" id="navbarSupportedContent">
                    
                        
                        </div>{}
                    </div>
                </nav>
                <header className="masthead">
                    <div className="image-spacer"></div>
                    <div className="container-find">
                        <div className="content-box">
                           
                            <div 
                                className="masthead-heading" 
                                dangerouslySetInnerHTML={{ __html: config.servizi[domain].titolo_homepage }}
                            />
                        
                            <div 
                                className="masthead-subheading" 
                                dangerouslySetInnerHTML={{ __html: config.servizi[domain].sottotitolo_homepage }}
                            />
                            <hr/>
                            <a className="homeButton" onClick={()=>{context.setTipoHomeForm("registrazione");navigate('/signup');}}><Lang w={"registrati"} page={"homepage"}/></a>
                            <a className="homeButton" onClick={()=>{context.setTipoHomeForm("login");navigate('/login');}}><Lang w={"accedi"} page={"homepage"}/></a>
                        </div>
                    </div>
                </header>

                <section className="section_recensioni">
                    <h2 className="heading_sezione_coppie">
                        <Lang w={"sezione_coppie"} page={"homepage"} placeholders={{servizio:config.servizi[domain].title}}/>
                    </h2>
                    <Coppie quante={5}/>
                </section>

                <section className="page-section personal-container" id="services">
                    <div className="container">
                        <div className="text-center">
                            <h2 className="section-heading text-uppercase"><Lang w={"perche"} page={"homepage"}/> {config.servizi[domain].title}</h2>
                            
                        </div>
                        <div className="row text-center">
                            <div className="col-md-4">
                                <span className="fa-stack fa-4x">
                                    <svg className="svg-inline--fa fa-circle fa-w-16 fa-stack-2x colore_cerchi" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg> <i className="fas fa-circle fa-stack-2x colore_cerchi"></i> 
                                    <i className="fas fa-shield-alt fa-stack-1x fa-inverse"></i> 
                                </span>
                                <h4 className="my-3"><Lang w={"sicurezza"} page={"homepage"} placeholders={{servizio:config.servizi[domain].title}}/></h4>
                                <p className="text-muted"><Lang w={"desc_sicurezza"} page={"homepage"}/></p>
                            </div>
                            <div className="col-md-4">
                                <span className="fa-stack fa-4x">
                                    <svg className="svg-inline--fa fa-circle fa-w-16 fa-stack-2x colore_cerchi" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg> <i className="fas fa-circle fa-stack-2x colore_cerchi"></i> 
                                    <i className="fas fa-camera fa-stack-1x fa-inverse"></i> 
                                </span>
                                <h4 className="my-3"><Lang w={"aumenta_visibilita"} page={"homepage"}/></h4>
                                <p className="text-muted"><Lang w={"desc_visibilita"} page={"homepage"}/></p>
                            </div>
                            <div className="col-md-4">
                                <span className="fa-stack fa-4x">
                                    <svg className="svg-inline--fa fa-circle fa-w-16 fa-stack-2x colore_cerchi" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg> <i className="fas fa-circle fa-stack-2x colore_cerchi"></i> 
                                    <i className="fas fa-heart fa-stack-1x fa-inverse"></i> 
                                   
                                </span>
                                <h4 className="my-3"><Lang w={"cerca_persona_adatta"} page={"homepage"}/></h4>
                                <p className="text-muted"><Lang w={"desc_persona_adatta"} page={"homepage"} placeholders={{servizio:config.servizi[domain].title}}/></p>
                            </div>
                        </div>
                    </div>
                </section>

                

                <div className="footer d-lg-block">
        <div className="container mb-0">
        <div className="mb-0">
            {config.servizi[domain].legal_link?.faq !== "#" && (
            <nav>
                
                <Link target="_blank" to={config.servizi[domain].legal_link.faq}><Lang w={"faq"} page={"footer"}/></Link>
                <Link target="_blank" to={config.servizi[domain].legal_link.termini}><Lang w={"termini"} page={"footer"}/></Link>
                <Link target="_blank" to={config.servizi[domain].legal_link.privacy}><Lang w={"privacy"} page={"footer"}/></Link>
                <Link target="_blank" to={config.servizi[domain].legal_link.cookie}><Lang w={"cookie"} page={"footer"}/></Link>
                <Link target="_blank" to={config.servizi[domain].legal_link.contatti}><Lang w={"contact_us"} page={"footer"}/></Link>
            </nav>
            )}
        </div>
        <img className="creditCardFlags" src="/img/credit-card-icons.png" border="0" />
        <p className="font-08 mb-0">{config.servizi[domain].company_name} &copy; - {config.servizi[domain].company_address} </p>
    </div>

   

    </div>
               
        </div>)

}
